import { functionFrom, FunctionLibrary, getFunctionSignature, spreadParam } from '../FunctionDefinition';
import { TYPES } from '../Types';

const concat = functionFrom(
  'concat',
  spreadParam({ name: 'str', type: TYPES.string }),
  TYPES.string,
  (_ctx, ...strs) => strs.join(''),
  'Concatenates any number of strings into a single string.',
);

export const STRING_FUNCTIONS = {
  [getFunctionSignature(concat)]: concat,
} satisfies FunctionLibrary;
